"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _inlineDiv = require("./inlineDiv");

var _inlineDiv2 = _interopRequireDefault(_inlineDiv);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _inlineDiv2.default;